import { DefaultLayout, DefaultLayoutProps } from '@/app/layouts/DefaultLayout.tsx'
import { cn } from '@lair-finance/util'
import { Outlet } from 'react-router-dom'

export function RestakeLayout({ contentClassName, ...props }: DefaultLayoutProps) {
  return (
    <DefaultLayout contentClassName={cn('relative !pt-0', contentClassName)} {...props}>
      <Outlet />
    </DefaultLayout>
  )
}
